var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card shadow-md rounded-xl ml-auto mr-auto",staticStyle:{"display":"flex","justify-content":"center"},style:({width: _vm.getWidth(), height: _vm.getHeight()})},[_c('img',{class:{
    'svg-accent-dark':(_vm.isDarkTheme && !_vm.isAnswerCard),
    'svg-accent-light':(!_vm.isDarkTheme && !_vm.isAnswerCard),
    'svg-default-color':(_vm.isAnswerCard) },attrs:{"src":_vm.image,"width":_vm.getWidth(),"height":_vm.getHeight()}})])}
var staticRenderFns = []

export { render, staticRenderFns }